module.exports = __webpack_public_path__ + "img/services-icon-1.6409b049.png";